module.exports = __webpack_public_path__ + "img/undraw_confidential_letter_w6ux.ac8abd8b.svg";